var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button"},[_vm._v("Go")])
}
var staticRenderFns = []

export { render, staticRenderFns }